import React from "react";
import { IonPopover } from "@ionic/react";
import { format, isToday } from "date-fns";
import classNames from "classnames";
import { ProgramData } from "@interfaces/Interfaces";
import { DayPicker, getDefaultClassNames } from "react-day-picker";
import WeekDayRenderer from "@components/programs/evidenceParts/WeekdayRenderer";
import * as ProgramUtils from "@utils/programUtils";

const defaultClassNames = getDefaultClassNames();

interface StartDateSelectionProps {
  program: ProgramData;
  startDate: Date | null;
  startDatePickerVisible: boolean;
  onStartDateChange: (date: Date) => void;
  onStartDatePickerVisibilityChange: (visible: boolean) => void;
}

const StartDateSelection: React.FC<StartDateSelectionProps> = (props) => {
  const openStartDatePicker = (): void => {
    props.onStartDatePickerVisibilityChange(true);
  };

  if (!ProgramUtils.showStartDateInDetailsPage(props.program, props.program.ID)) {
    return null;
  }

  return (
    <>
      <IonPopover
        trigger="startDatePicker"
        id="date-range-picker"
        isOpen={props.startDatePickerVisible}
        arrow={false}
        onDidDismiss={() => props.onStartDatePickerVisibilityChange(false)}
      >
        <div className="pt-2 p-5">
          <DayPicker
            mode={"single"}
            weekStartsOn={1}
            selected={props.startDate ?? new Date()}
            defaultMonth={props.startDate ?? new Date()}
            onSelect={(data: Date | undefined) => {
              data && props.onStartDateChange(data);
            }}
            classNames={{
              selected: `bg-cta-blue text-white rounded-[10px]`,
              today: isToday(props.startDate ?? new Date()) ? "text-white" : getDefaultClassNames().today,
              month_caption: `${defaultClassNames.month_caption} text-[#595959] font-normal`,
            }}
            components={{
              Weekday: (el) => <WeekDayRenderer element={el} />,
            }}
          />
        </div>
      </IonPopover>
      <div className="mt-4">
        <div className="editRolesHeader mb-2">{"Start date"}</div>
        <div
          id="startDatePicker"
          className="onboardingDateContainer"
          onClick={() => openStartDatePicker()}
        >
          <div className={classNames("onboardingDateText", { onboardingDateTextSelected: true })}>
            <div>{props.startDate ? format(new Date(props.startDate), "dd / MM / yyyy") : "Tap to add start date"}</div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StartDateSelection;
